import FilterBar from '../../components/FilterBar';
import { Select, MenuItem, CircularProgress, TextField } from '@mui/material';
import { DepartmentFilter } from './departmentsTypes';
import { useFindAlldepartmentsQuery } from '../../api/api-hooks';

interface Props {
  filters: DepartmentFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: DepartmentFilter;
}

const DepartmentsFilterBar = ({
  filters,
  setFilters,
  initialFilters,
}: Props) => {
  const { data: departments } = useFindAlldepartmentsQuery({});
  if (departments === undefined) return <CircularProgress></CircularProgress>;

  return (
    <FilterBar
      filters={filters}
      setFilters={setFilters}
      initialFilters={initialFilters}
      filterConstraintChecker={(name, value) => true}
      children={(handler: (event: any) => void) => [
        <TextField
          name='companyName'
          label='Company Name'
          variant='outlined'
          value={filters.companyName}
          onChange={handler}
        />,
        <TextField
          name='departmentName'
          label='Department Name'
          variant='outlined'
          value={filters.departmentName}
          onChange={handler}
        />,
        <Select
          name='timeToExpiration'
          value={filters.timeToExpiration}
          variant='outlined'
          displayEmpty={true}
          renderValue={(value: any) =>
            value ? value : 'Filter By Time To Expiration'
          }
          onChange={handler}
        >
          <MenuItem value='1 Month'>1 Month</MenuItem>
          <MenuItem value='3 Months'>3 Months</MenuItem>
          <MenuItem value='6 Months'>6 Months</MenuItem>
        </Select>,
      ]}
    />
  );
};

export default DepartmentsFilterBar;
